/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Workflow = {
  type: 'Enum',
} as const;
